import { Alert, Spinner } from "react-bootstrap";
import { useQueries } from "@tanstack/react-query";

import { agentQueries } from "../queries";
import ASHComponentCard from "./stateComponents/ASHComponentCard";
import { AgentConfig, CommonAPI } from "../types";
import { AgencyTagFilter } from "../tag/AgencyTagFilter";

const AgentStateCards = ({
  sessionId,
  agentId,
  momentId,
  commonAPI,
  agentConfig,
  agencyTagFilter,
}: {
  sessionId: string;
  agentId: string;
  momentId?: number;
  commonAPI: CommonAPI;
  agentConfig?: AgentConfig;
  agencyTagFilter: AgencyTagFilter;
}) => {
  const [stateQuery, presentationQuery] = useQueries({
    queries: [
      {
        queryKey: agentQueries.getPublicState(sessionId, agentId, momentId),
        queryFn: () =>
          commonAPI.fetchAgentPublicState({ sessionId, agentId, momentId }),
        staleTime: Infinity,
      },
      {
        queryKey: agentQueries.getPresentation(sessionId, agentId, momentId),
        queryFn: () =>
          commonAPI.fetchAgentPresentation({ sessionId, agentId, momentId }),
        staleTime: Infinity,
      },
    ],
  });

  const isPending = stateQuery.isPending || presentationQuery.isPending;
  const isError = stateQuery.isError || presentationQuery.isError;
  const error = stateQuery.error || presentationQuery.error;

  const agentState = stateQuery.data;
  const agentPresentation = presentationQuery.data;

  return (
    <>
      {isPending && <Spinner />}
      {isError && error && (
        <Alert variant="warning">
          Error loading agent state:<div>{error.message}</div>
        </Alert>
      )}
      {!isPending &&
        !isError &&
        agentState?.map((componentState) => {
          return (
            <ASHComponentCard
              key={componentState.id}
              componentState={componentState}
              componentPresentation={agentPresentation?.find(
                (component) => component.id === componentState.id
              )}
              sessionId={sessionId}
              agentId={agentId}
              agentConfig={agentConfig}
              agencyTagFilter={agencyTagFilter}
            />
          );
        })}
    </>
  );
};

export default AgentStateCards;
